import { Component, Input, OnInit } from '@angular/core';
import { RenaultBannerMinimizedDTO } from 'src/app/models/renault-banner-dto';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {

  @Input() model: RenaultBannerMinimizedDTO;

  constructor() { }

  ngOnInit(): void {}

}
